/** @jsx jsx needed to get Storybook to render */
import { jsx } from '@emotion/core';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Footer from './Footer';

const GatsbyFooter = ({ footer }) => {
  // get menu query for footer menu
  const footerMenuQuery = graphql`
    {
      sanityFooterMenu(footerMenuName: { eq: "Footer Menu" }) {
        _rawIcon(resolveReferences: { maxDepth: 10 })
        headingText
        _rawButton(resolveReferences: { maxDepth: 10 })
        description
        phoneNumber
        _rawFooterMenuColumns(resolveReferences: { maxDepth: 100 })
        _rawSubscribeForm(resolveReferences: { maxDepth: 100 })
        _rawSocialIcons(resolveReferences: { maxDepth: 100 })
        _rawCopyright(resolveReferences: { maxDepth: 100 })
      }
    }
  `;

  let { sanityFooterMenu = {} } = useStaticQuery(footerMenuQuery) || {};

  if (footer !== null) sanityFooterMenu = footer;

  return <Footer sanityFooterMenu={sanityFooterMenu} />;
};

GatsbyFooter.propTypes = {
  footer: PropTypes.shape({}),
};

GatsbyFooter.defaultProps = {
  footer: null,
};

export default GatsbyFooter;
